export const INTERACTION_ANALYTICS_EVENTS = {
  created: "create interaction"
} as const;

export type InteractionCreateSource = "global_create" | "incoming_call";

export const INTERACTION_CREATE_SOURCES = {
  globalCreate: "global_create",
  incomingCall: "incoming_call"
} as const satisfies Record<string, InteractionCreateSource>;
